import settings from "../utils/settings";

const isAdmin = () => {
  const { roleName } = settings();
  if (roleName?.toLowerCase() === "administrator") return true;
  else return false;
};

const isAdminUser = () => {
  const { username } = settings();
  if (username === "admin") return true;
  return false;
};

const useCheckPermission = () => {
  const checkWritePermission = async (code) => {
    if (isAdmin()) return true;
    const { token } = settings();
    //Always recheck user permission
    const homeRawResult = await fetch(
      `${process.env.REACT_APP_API_ENDPOINT}/merchants/home`,
      {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      }
    );
    if (!homeRawResult.ok) return false;
    const jsonHomeResult = await homeRawResult.json();
    const currentAuthorizes = jsonHomeResult.payload.authorizes;
    const result = currentAuthorizes.find((cur) => cur.object_code === code);

    if (result) {
      if (result.action_codes?.find((act) => act === "Write")) return true;
      return false;
    } else {
      return false;
    }
  };

  const checkReadPermission = async (code) => {
    if (isAdmin()) return true;
    const { token } = settings();
    //Always recheck user permission
    const homeRawResult = await fetch(
      `${process.env.REACT_APP_API_ENDPOINT}/merchants/home`,
      {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      }
    );
    const jsonHomeResult = await homeRawResult.json();
    const currentAuthorizes = jsonHomeResult.payload.authorizes;
    const result = currentAuthorizes.find((cur) => {
      return cur.object_code === code;
    });

    if (result) {
      if (result.action_codes?.find((act) => act === "Read")) return true;
      return false;
    } else {
      return false;
    }
  };

  return { checkWritePermission, checkReadPermission };
};

export default useCheckPermission;
export { isAdminUser };
